import { ReactElement, useState } from 'react';
import { useClearRmaInvoicesAction, useRmaInvoiceEffect } from '@client/myAccount/rma/hooks';
import { Form } from './Form';
import {
  FIELD_NAME,
  FormValuesType,
} from './FormContainer.types';

export const FormContainer = (): ReactElement => {
  const [searchValues, setSearchValues] = useState<{
      [FIELD_NAME.debitorId]: string | undefined
      [FIELD_NAME.invoiceId]: string
    }>({
      [FIELD_NAME.debitorId]: undefined,
      [FIELD_NAME.invoiceId]: '',
    });
  const rmaInvoiceData = useRmaInvoiceEffect(
    searchValues[FIELD_NAME.invoiceId],
    searchValues[FIELD_NAME.debitorId],
  );
  const clearRmaInvoices = useClearRmaInvoicesAction();

  const handleSubmit = (values: FormValuesType): void => {
    clearRmaInvoices();
    setSearchValues({
      [FIELD_NAME.debitorId]: values[FIELD_NAME.debitorId],
      [FIELD_NAME.invoiceId]: values[FIELD_NAME.invoiceId],
    });
  };

  return (
    <Form
      isSubmitting={rmaInvoiceData.wasStarted && rmaInvoiceData.isLoading}
      onSubmit={handleSubmit}
      rmaInvoiceData={rmaInvoiceData}
    />
  );
};

export {
  FIELD_NAME,
};
